import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { AppManageSubscriptionsInvoicesRouteModel } from 'walden-fast/routes/app/manage/subscriptions/invoices';
import type { SortDirection } from 'walden-fast/types/pagination';

export default class AppManageSubscriptionsInvoicesController extends Controller {
  declare model: AppManageSubscriptionsInvoicesRouteModel;

  queryParams = ['page', 'pageSize', 'sortField', 'sortDirection'];

  @tracked
  page = 1;

  @tracked
  pageSize = 5;

  @tracked
  sortField = '';

  @tracked
  sortDirection: SortDirection = 'none';

  @action
  sort(field: string, direction: SortDirection) {
    this.sortField = field;
    this.sortDirection = direction;
  }

  sortDirectionForField = (field: string) => {
    return this.sortField === field ? this.sortDirection : 'none';
  };
}
